(function(){

    angular.module('tmx-app').controller('bulkUploadCtrl', ['BulkUploadService',
        'resolvedData','menu','ToastService', 'tmxUtility','$window','lookupService',
    
        function BulkUploadCtrl( BulkUploadService, resolvedData,menu,ToastService,tmxUtility,$window,lookupService){
  
            var bulkUploadVM=this;
            bulkUploadVM.menu = menu;
            bulkUploadVM.UploadTypeLkp = resolvedData.bukUploadTypes;
            bulkUploadVM.selectedBulk = { Name: null, requiredParams: {}, TemplateName: null };
            bulkUploadVM.acceptFiles = '.csv,.xls,.xlsx';
            bulkUploadVM.headers = { 'responseType': 'arraybuffer'};
            bulkUploadVM.model = {params:{}};
            var lovRegex = new RegExp("lov\([\w\s:]*\)");
            function HandleResolveData() {
                if (!tmxUtility.exists(resolvedData)) {
                    console.error('Resolved Data is empty');
                    return;
                }
                if (tmxUtility.exists(resolvedData.Organizations.data)) {
                    var resolvedOrg = resolvedData.Organizations.data.filter(x=>x.Active_Flag ===1);
                    bulkUploadVM.OrgLkp = resolvedOrg.map(x => ({ LookupId: x.OrganizationId, VisibleValue: x.OrganizationName,HiddenValue:x.OrganizationId }));
                }
                if (tmxUtility.exists(resolvedData.Products.data)) {
                   
                    bulkUploadVM.ProductLkp = resolvedData.Products.data;
                }
        
            }
            bulkUploadVM.afterImport = function(resp) {
                if(resp) {
                    if(resp.status==500) {
                        ToastService.showCustomToast("error",resp.statusText);
                        return;
                       
                        
                    }
                    else if(resp.status==400) {
                        ToastService.showCustomToast("error",resp.statusText);
                        var file = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        if (file.size != 0) {
                            saveAs(file, "Errors.xlsx");
                            return;
                        }

                    }
                }
            }
            bulkUploadVM.upload = function () {
                var file = bulkUploadVM.files[0];
                var acceptExt = bulkUploadVM.acceptFiles.split(',');
                var fileAccepted = false;
                for (var i = 0; i < acceptExt.length; i++) {
                    if (bulkUploadVM.files[0].name.substring(bulkUploadVM.files[0].name.lastIndexOf('.'), bulkUploadVM.files[0].name.length) == acceptExt[i]) {
                        fileAccepted = true;
                    }
                }
                if (!fileAccepted) {
                    bulkUploadVM.error = "Invalid file format. Expected file format(s): " + bulkUploadVM.scope.acceptFiles;
                    return;
                }
                //fileUpload.upload(file, bulkUploadVM.scope.url)
                BulkUploadService.UploadData(file,"CustomerMaster",13)
                    .then(function (resp) {
                        if (!angular.isDefined(bulkUploadVM.scope.shouldShowResponseDialog) || bulkUploadVM.scope.shouldShowResponseDialog == true) {
                            if (resp.data.status.message) {
                                bulkUploadVM.showErrorDialog(resp.data.status.message);
                            }
                            else {
                                ToastService.showCustomToast("success", bulkUploadVM.scope.successMsg ? bulkUploadVM.scope.successMsg : "Upload Successful");
                            }
                        }
    
    
                        if (bulkUploadVM.scope.afterUpload)
                            bulkUploadVM.scope.afterUpload(resp);
                    }, function (resp) {
    
                        if (bulkUploadVM.scope.afterUpload)
                            bulkUploadVM.scope.afterUpload(resp);
                    }).finally(function () {
                        bulkUploadVM.removeAllFiles();
                    });
    
            };

            bulkUploadVM.PrepareUploadFileParams = function(){
                let url = "BulkUpload/BulkUploadFile/"+bulkUploadVM.selectedBulk.TemplateName;
                if(tmxUtility.exists(bulkUploadVM.model.params) && Object.keys(bulkUploadVM.model.params).length > 0){
                    url+="/"+ Object.entries(bulkUploadVM.model.params).map(e => e.join('=')).join(',');
                }
                return url;
            }
    
            bulkUploadVM.importURL = function () {
                if (BulkUploadCtrl.model)
                    return "BulkUpload/BulkUpload" + bulkUploadVM.selectedBulk.TemplateName + BulkUploadCtrl.model.param;
                else
                    return "BulkUpload/BulkUpload" + bulkUploadVM.selectedBulk.TemplateName;
            }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
            bulkUploadVM.BulkUploadService = BulkUploadService;
  

  //**********functions****************
  
            function RefreshScreen() {
                bulkUploadVM.selectedBulk = { Name: null, requiredParams: {}, TemplateName: null };
                bulkUploadVM.model = {params:{}};
            }
            bulkUploadVM.getTemplateByType = function (selectedType) {
                if (!tmxUtility.exists(selectedType)) { // In case of clear the dropdown
                    RefreshScreen();
                    return;
                }
                var selectedBulk = bulkUploadVM.UploadTypeLkp.find(x => x.LookupId == selectedType);
                bulkUploadVM.selectedBulk.Name = selectedBulk.VisibleValue;
                if (tmxUtility.exists(selectedBulk, 'HiddenValue')) {
                    bulkUploadVM.selectedBulk.TemplateName = selectedBulk.HiddenValue;
                }
                if (tmxUtility.exists(selectedBulk, 'Description')) {
                    ResolveReportParameters(selectedBulk.Description);
                }
            }
            bulkUploadVM.DownloadSample = function () {
                $window.location.href = "/assets/templates/" +bulkUploadVM.selectedBulk.TemplateName+ ".xlsx" ;
            }
            bulkUploadVM.checkDisabled = function () {
                if(!tmxUtility.exists(bulkUploadVM.Type)){
                    return false;
                }
                if(bulkUploadVM.selectedBulk) {
                    if(bulkUploadVM.selectedBulk.requiredParams) {
                        for (const key in bulkUploadVM.selectedBulk.requiredParams) {
                            if(!tmxUtility.exists(bulkUploadVM.model.params[key])){
                                return false;
                            }
                        }   
                    }
                    
                }
                return true;
            }
            
            function ResolveReportParameters(selectedBulkDescription) {
                var lovTypeParams = [];
                var descArray = selectedBulkDescription.split(','); // Split the comma separated description into array
                bulkUploadVM.selectedBulk.requiredParams = {};
                descArray.forEach(item => {
                    if (lovRegex.test(item)) { // put Lovs in separate list
                        lovTypeParams.push(item);
                    }
                    else {
                        bulkUploadVM.selectedBulk.requiredParams[item] = true
                    }
                });
                if (lovTypeParams.length > 0) {
                    lovTypeParams.forEach(lov => populateLovTypeParameters(lov));
                }

                function populateLovTypeParameters(lov) {
                    let lovDesc = lov.substring(lov.indexOf("(") + 1, lov.lastIndexOf(')'));
                    var lovParams = lovDesc.split(':');
                    if (lovParams.length < 3) {
                        console.error(`Lov parameters are not defined for LOV: '${lov}'`);
                        return;
                    }
                    bulkUploadVM.lovParameters.push({ paramName: lovParams[0].trim(), options: lookupService.getLocalLookupsByType(lovParams[1].trim()), label: lovParams[2].trim() });
                }
            }
            (function InitializePage() {
                HandleResolveData();
            })();
        }]); 
})();